import {NormalizedAqForecastModel} from './types';

/**
 * The air quality forecast models, keyed the way the API identifies them.
 *
 * The weather side has had `SupportedForecastModelList` since the beginning;
 * air quality never got one, so the detail screen printed
 * `metadata.forecast_model` and `metadata.mesh_size` verbatim — "CAMS_EUROPE
 * 0P10", two internal identifiers.
 *
 * These are the five `ForecastModel` rows with `forecast_type=AIR_QUALITY` in
 * production. Only the two CAMS models are published today; NAQFC, HRRR Smoke
 * and GEOS-CF are built but switched off. They are listed anyway — the entry
 * costs one line and it is what stops the label regressing to the raw enum on
 * the day one of them is published.
 *
 * `meshSize` is kilometres, like `NormalizedForecastModel.meshSize`, so the
 * caller converts it to the user's distance unit rather than reprinting the
 * server's degree code.
 */
export const SupportedAqForecastModelList: NormalizedAqForecastModel[] = [
  {
    key: 'CAMS_EUROPE',
    serverId: {
      forecastModel: 'CAMS_EUROPE',
      meshSize: '0P10',
    },
    type: 'regional',
    meshSize: 10,
    title: 'CAMS Europe',
    editor: 'Copernicus',
  },
  {
    key: 'CAMS_GLOBAL',
    serverId: {
      forecastModel: 'CAMS_GLOBAL',
      meshSize: '0P40',
    },
    type: 'global',
    meshSize: 40,
    title: 'CAMS Global',
    editor: 'Copernicus',
  },
  {
    key: 'NAQFC',
    serverId: {
      forecastModel: 'NAQFC',
      meshSize: '0P05',
    },
    type: 'regional',
    meshSize: 5,
    title: 'NAQFC',
    editor: 'NOAA',
  },
  {
    key: 'HRRR_SMOKE',
    serverId: {
      forecastModel: 'HRRR_SMOKE',
      meshSize: '0P03',
    },
    type: 'regional',
    meshSize: 3,
    title: 'HRRR Smoke',
    editor: 'NOAA',
  },
  {
    key: 'GEOS_CF',
    serverId: {
      forecastModel: 'GEOS_CF',
      meshSize: '0P25',
    },
    type: 'global',
    meshSize: 25,
    title: 'GEOS-CF',
    editor: 'NASA',
  },
];
